import { render, staticRenderFns } from "./FuelLabel.vue?vue&type=template&id=60e05026&scoped=true&"
import script from "./FuelLabel.vue?vue&type=script&lang=ts&"
export * from "./FuelLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FuelLabel.vue?vue&type=style&index=0&id=60e05026&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e05026",
  null
  
)

export default component.exports